import get from 'lodash/get'

export default function select(selectors, defaultValue) {
  return input => {
    return get(input, selectors, defaultValue)
  }
}
